import { matchPath } from "react-router-dom";

import { APP_ROUTES } from "../constants";

// LoginPlugin owns /callback; /login keeps its logged-out redirect.
const KNOWN_PATHS = [...Object.values(APP_ROUTES), "/callback", "/login"];

export const isUnknownPath = (pathname: string): boolean => {
  let decoded: string;
  try {
    decoded = decodeURI(pathname);
  } catch {
    return false;
  }
  return !KNOWN_PATHS.some((path) => matchPath(path, decoded));
};
